export const END_POINT_AUTH_TOKEN = `/oauth/token`;
export const END_POINT_ADMIN = `/admins`;
export const END_POINT_ADMIN_LOGIN = `/auth/login`;
export const END_POINT_VEHICLE = `/vehicles`;
export const END_POINT_STORAGE = `/storage`;
